module.exports = __webpack_public_path__ + "img/news3-8.c31c5342.jpeg";